import buildSimpleStringFilter from '../buildSimpleStringFilter'

const ListingTypeFilter = buildSimpleStringFilter({
  key: 'listingType',
  expandedOnInit: false,
})

export default ListingTypeFilter
